import { Observable , of } from 'rxjs';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { filter, tap, first, map, flatMap } from 'rxjs/operators';

@Injectable()
export class VersionChekerInterceptor implements HttpInterceptor {
    private cachedVersion: string;
    private refreshPromptShowing: boolean = false;

    constructor(private snackBar: MatSnackBar) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {    
        return next.handle(req).pipe(
            tap((event: any) => of(event).pipe(
                first(),
                filter((event: HttpEvent<any>) => event instanceof HttpResponse),
                map((event: HttpResponse<any>): string => event.headers.get('X-Attensa-Version')),
                tap((version: string) => this.cachedVersion = !this.cachedVersion && version ? version : this.cachedVersion),
                filter((version: string) => !this.refreshPromptShowing && this.cachedVersion && version && (version !== this.cachedVersion) && (version !== 'unknown')),
                tap(() => this.refreshPromptShowing = true),
                flatMap(() => this.snackBar.open('There is a new version available, shall we fetch it?', 'OK', { verticalPosition: 'top' }).afterDismissed()),
                filter(info => info.dismissedByAction === true)
            ).subscribe(() => window.location.reload()))
        );
    }
}
